import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "../shared/toastr.service";

@Injectable({
  providedIn: "root",
})
export class ClipboardService {
  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  copy(text: string, successKey = "digitalCards.linkCopied"): void {
    if (!text) return;
    navigator.clipboard.writeText(text).then(
      () => this.toastr.success(this.translate.instant(successKey) as string),
      () => {},
    );
  }
}
